<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('FaceRecognitionrecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="logFaceForm" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="logFaceForm.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="logFaceForm.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP2')">
            <el-input v-model="logFaceForm.helmetId" clearable :placeholder="$t('serialNumberP2')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('faceUserName')">
            <el-input v-model="logFaceForm.faceUserName" clearable :placeholder="$t('faceUserName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('detectResult')">
            <el-select
              v-model="logFaceForm.detectResult"
              clearable
              :placeholder="$t('detectResult')"
              :popper-append-to-body="false"
            >
              <el-option :label="$t('fails')" value="0"></el-option>
              <el-option :label="$t('successs')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Recordtime')" class="datetime">
            <el-date-picker
              v-model="logFaceForm.startTime"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              @change="selectDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="logFaceForm.endTime"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="true"
              @change="selectEndDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button type="primary" class="serachBtn letter_delet" v-has="'log:data:delete'" v-preventReClick="1000" @click="handleDelet">{{
              $t('batchDelete')
            }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{
              $t('exportButton')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table组件 -->
        <Table
          v-loading="loading"
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :type="type"
          ref="tanleAssembly"
          @getList="getList"
          @operate="operationEvent"
          :currentPage="currentPage"
          :pageSize="pageSize"
          :playBtnTime="playBtnTime"
          :operationWidth="140"
          @sortChange="handleSort"
        ></Table>
        <!-- 页脚 -->
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 图片弹窗 -->
    <el-dialog
      :visible.sync="dialogFace"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="deleteUrl"
    >
      <el-form :model="fromData" ref="imageForm">
        <img
          style="text-align: center;width: 100%;height: 100%;"
          class="el-upload-list__item-thumbnail"
          :src="photoUrl"
          alt=""
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Table from '@/components/NewTable'
import { faceDetectPage, faceDetectDelete, faceDetectId } from '@/api/log'
import { datetimeFullZero, datetimeFull } from '@/api/common'
import { getOus } from '@/api/UserList'
import { getExportFaceDetect } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  data() {
    return {
      ouList: [],
      logFaceForm: {
        //查询表单字段
        ouName: '',
        ouId: '',
        helmetId: '',
        faceUserName: '',
        startTime: beforeWeekDate() + ' 00:00:00',
        endTime: nowDate() + ' 23:59:59',
        detectResult: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      fileType: [],
      childOperats: [],
      childoperationMap: [],
      // 用于批量删除 公共组件类型判断
      type: 'Faceprint',
      formLabelWidth: '160px',
      dialogFace: false,
      playBtnTime: 0,
      fromData: {
        id: '',
        photoUrl: '',
      },
      photoUrl: '',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      // 查询提示
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if (this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'), //提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let startTime = ''
      let endTime = ''
      if (this.logFaceForm.startTime) {
        startTime = datetimeFullZero(this.logFaceForm.startTime)
      }
      if (this.logFaceForm.endTime) {
        endTime = datetimeFull(this.logFaceForm.endTime)
      }
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        startTime: startTime,
        endTime: endTime,
        ouId: this.logFaceForm.ouId,
        ouName: this.logFaceForm.ouName,
        helmetId: this.logFaceForm.helmetId,
        faceUserName: this.logFaceForm.faceUserName,
        detectResult: this.logFaceForm.detectResult,
        sortColName: this.logFaceForm.sortColName,
        useAsc: this.logFaceForm.useAsc,
      }
      getExportFaceDetect(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('FaceRecognitionrecord') + '.xls')
      })
    },
    // 排序
    handleSort(data) {
      this.logFaceForm.sortColName = !data.order ? null : data.prop
      this.logFaceForm.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.logFaceForm.ouName = data.name
      this.logFaceForm.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.logFaceForm.ouId = null
        this.logFaceForm.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 选择日期时触发
    selectDate(e) {
      if (e === null) {
        this.logFaceForm.startTime = ''
      }
    },
    selectEndDate(e) {
      if (e === null) {
        this.logFaceForm.endTime = ''
      }
    },
    handleSizeChange(val) {
      // 清空批量选择的数据
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this._getOperations()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this._getOperations()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    // 批量删除
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.logFaceForm.startTime, this.logFaceForm.endTime)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this._getOperations()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this._getOperations()
      }
    },
    // 获取操作数据
    _getOperations() {
      this.loading = true
      let startT = ''
      let endT = ''
      if (this.logFaceForm.startTime) {
        startT = datetimeFullZero(this.logFaceForm.startTime)
      }
      if (this.logFaceForm.endTime) {
        endT = datetimeFull(this.logFaceForm.endTime)
      }
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        startTime: startT,
        endTime: endT,
        ouId: this.logFaceForm.ouId,
        ouName: this.logFaceForm.ouName,
        helmetId: this.logFaceForm.helmetId,
        faceUserName: this.logFaceForm.faceUserName,
        detectResult: this.logFaceForm.detectResult,
        sortColName: this.logFaceForm.sortColName,
        useAsc: this.logFaceForm.useAsc,
      }
      faceDetectPage(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          let data = res.value.list
          data.forEach(item => {
            item.detectResult = item.detectResult === 0 ? this.$t('fails') : this.$t('successs')
          })
          this.tableData = data
          this.totalData = res.value.total
        }
      })
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._deleteOperationLog(row)
      } else if (row.type === 'look') {
        this.faceInfo(row.value)
      }
    },

    // 根据id查询人脸数据
    faceInfo(row) {
      this.photoUrl = ''
      this.faceData = Object.assign({}, row)
      let param = { id: row.id }
      faceDetectId(param).then(res => {
        if (res.state === 0) {
          this.photoUrl = res.data.imageUrl
        }
      })
      this.dialogFace = true
    },
    deleteUrl() {
      this.photoUrl = ''
    },
    //  删除操作日志
    _deleteOperationLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = []
        params.push(row.value.id)
        faceDetectDelete(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this._getOperations()
          }
        })
      })
    },
    // 基础配置数据
    basicConfig() {
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'faceUserName',
          label: this.$t('faceUserName'),
          sort: 'faceUserName',
        },
        {
          attrName: 'detectResult',
          label: this.$t('detectResult'),
          align: 'center',
          width: '140',
          sort: 'detectResult',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          align: 'center',
          width: '180',
          sort: 'logTimestamp',
        },
      ]
      // 操作
      this.dateOperation = [
        {
          operateName: this.$t('lookImage'),
          type: 'look',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: '',
          class: 'editClick',
        },
      ]
    },
  },
  created() {
    this.basicConfig()
    this._getOperations()
    this.getOusTree()
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 640px!important
  min-height 500px!important;/* no */
  overflow: auto
>>>.el-popper {
  min-width: 200px !important;
}
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.letter_delet
  margin-left: 10px
audio
  visibility: hidden
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 624px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
